define('drops/googleMap/googleMap',[
    'jquery',
    'when',
    'lq/drop',
    'lq/style'
], function ($, when, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            zoom: 13,
            selectedlocationOption: 'hard coded',
            address: 'Palm Jumeirah',
            mapType: 'roadmap',
            size: { x: 500, y: 500 },
            zoomAddr: 13,
            zoomCoor: 13
        }
    };

    var googleMapsInitQueue = [];
    var markers = [];

    window.initGoogleMapsForLicquidJs = function () {
        _.each(googleMapsInitQueue, function (callback) {
            callback();
        });
    };

    function GoogleMap(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$map = $('<div />')
            .attr('id', 'map-canvas')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
            });

            this.mapDeferred = when.defer();

        Style.renderStyles(this);
    };

    Drop.extend(GoogleMap, Drop);

    GoogleMap.typeName = 'GoogleMap';

    GoogleMap.prototype.preRender = function () {
        this.applyPosition();

        var deferred = when.defer();
        require([
                'google_maps'
            ],
            function() {
                deferred.resolve();
            });

        return deferred.promise;
    };

    GoogleMap.prototype.postRender = function () {
        this.createGoogleMap();
        if (this.isEventEnabled('locationSelected')) {
            this.addClickEventListenerToMap();
        }
        this.renderMap();
    };

    GoogleMap.prototype.createGoogleMap = function () {
        var myOptions = {
            mapTypeId: this.getMapType(this.data.mapType)
        };

        if (!this.map) {
            this.map = new google.maps.Map(document.getElementById('map-canvas'), myOptions);
        }
    }

    GoogleMap.prototype.addClickEventListenerToMap = function () {
        var self = this;

        google.maps.event.addListener(this.map, 'click', function(event) {
            if (self.data.latParam) {
                self.piping.parameters.locals.setValue(self.data.latParam, event.latLng.lat());
            }
            if (self.data.lngParam) {
                self.piping.parameters.locals.setValue(self.data.lngParam, event.latLng.lng());
            }
            if (self.data.addressParam) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'latLng': event.latLng
                }, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            self.piping.parameters.locals.setValue(self.data.addressParam, results[0].formatted_address);
                            self.triggerEventIfEnabled('locationSelected');
                        }
                    } else {
                        alert('Failed the geocoding of the following lat lng values: ' + event.latLng.lat() + ' ' + event.latLng.lng()
                               + '.\nLeave the \'Address parameter\' empty in the designer to skip the geocoding.')
                    }
                });
            } else {
                self.triggerEventIfEnabled('locationSelected');
            }
        });
    }

    GoogleMap.prototype.renderMap = function () {
        if (this.data.selectedlocationOption === 'hard coded') {
            if (this.data.address)
                this.goToAddress(this.data.address);
            else (this.data.lat && this.data.lng)
                this.goToCoordinates(this.data);
        } else if (this.data.selectedlocationOption === 'datasource addresses' || this.data.selectedlocationOption === 'datasource coordinates') {
            var self = this;
            if (this.data.selectedlocationOption === 'datasource addresses') {
                var geocoder = new google.maps.Geocoder();
                this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                    self.deleteMarkers(self.map);
                    if (data.Results.length !== 0) {
                        for (var i = 0; i < data.Results.length; i++) {
                            var resultAddress = data.Results[i][self.data.addressOutput];
                            if (resultAddress != null) {
                                geocoder.geocode({ 'address': resultAddress }, self.forwardGeoCode.bind(self, data.Results[i]));
                            }
                        }
                    } else {
                        self.setDefaults(self.map);
                    }
                });
            } else if (this.data.selectedlocationOption === 'datasource coordinates') {
                this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                    self.deleteMarkers(self.map);
                    var onlyNullFlag = true;
                    for (var i = 0; i < data.Results.length; i++) {
                        if (data.Results[i][self.data.latOutput] && data.Results[i][self.data.lngOutput]) {
                            self.$map.css({
                                visibility: 'visible'
                            })
                            onlyNullFlag = false;
                            var latlng = new google.maps.LatLng(
                                    data.Results[i][self.data.latOutput],
                                    data.Results[i][self.data.lngOutput]);

                            var marker = new google.maps.Marker({
                                position: latlng,
                                map: self.map,
                                draggable: false
                            });
                            markers.push(marker);
                            google.maps.event.addListener(marker, 'click', self.markerClicked.bind(self, data.Results[i]));
                        }
                    }
                    if (onlyNullFlag) {
                       self.setDefaults(self.map);
                    } else {
                       self.calculateMarkerBounds(self.map);
                    }
                });
            }
        }
        this.mapDeferred.resolve(this.map);
    };

    GoogleMap.prototype.clearValue = $.noop;

    GoogleMap.prototype.setValue = function (data) {
        this.goToLocation(data.value);
    };

    GoogleMap.prototype.goToLocation = function (value) {
        var self = this;

        if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.LatLng !== 'undefined') {
            if (self.data.selectedlocationOption === 'query address') {
                self.goToAddress(value);
            } else if (self.data.selectedlocationOption === 'query coordinates') {
                self.goToCoordinates(value);
            }
        } else {
            googleMapsInitQueue.push(function () {
                self.goToLocation(value);
            });
        }
    };

    GoogleMap.prototype.goToCoordinates = function (coordinates) {
        var self = this;

        try {

            if (coordinates.lat !== undefined && coordinates.lng !== undefined) {
                self.renderValue(coordinates);
            } else {
                var seperator = coordinates.indexOf(';');
                if (seperator != -1) {
                    var slat = coordinates.substring(0, seperator);
                    var slng = coordinates.substring(seperator + 1);
                    var flat = parseFloat(slat);
                    var flng = parseFloat(slng);
                    if ((flat < 85) && (flat > -85) && (flng < 180) && (flng > -180)) {
                        self.renderValue({
                            lat: flat,
                            lng: flng
                        });
                    }
                }
            }
        } catch (e) {
        }
    };

    GoogleMap.prototype.goToAddress = function (address) {
        var self = this;
        //amount of the geocode queries get limited by google
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var regex = /[(](-?[0-9]*.[0-9]*)[,][ ](-?[0-9]*.[0-9]*)[)]/;
                var result = regex.exec(results[0].geometry.location.toString());
                if (result.length >= 3) {
                    self.renderValue({
                        lat: result[1],
                        lng: result[2]
                    });
                }
            }
        });
    };

    GoogleMap.prototype.renderValue = function (data) {
        var self = this;

        var latlng = new google.maps.LatLng(data.lat, data.lng);

        var myOptions = {
            zoom: this.data.zoom,
            center: latlng,
            mapTypeId: this.getMapType(self.data.mapType)
        };

        this.map.setOptions(myOptions);

        new google.maps.Marker({
            position: latlng,
            map: this.map,
            draggable: true
        });
    };

    GoogleMap.prototype.getMapType = function (mapType) {
        switch (mapType) {
            case 'terrain':
                return google.maps.MapTypeId.TERRAIN;
            case 'satellite':
                return google.maps.MapTypeId.SATELLITE;
            case 'hybrid':
                return google.maps.MapTypeId.HYBRID;
            default:
                return google.maps.MapTypeId.ROADMAP;
        }
    };

    GoogleMap.prototype.markerClicked = function(markerData) {
        this.triggerEventIfEnabled('clicked', markerData[this.data.eventArg]);
    };

    GoogleMap.prototype.forwardGeoCode = function(markerData, results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            this.$map.css({
                visibility: 'visible'
            })
            var regex = /[(](-?[0-9]*.[0-9]*)[,][ ](-?[0-9]*.[0-9]*)[)]/;
            var result = regex.exec(results[0].geometry.location.toString());
            if (result.length >= 3) {
                var latlng = new google.maps.LatLng(
                    result[1],
                    result[2]);
                var marker = new google.maps.Marker({
                    position: latlng,
                    map: this.map,
                    draggable: false,
                });
                markers.push(marker);
                var self = this;
                google.maps.event.addListener(marker, 'click', self.markerClicked.bind(self, markerData));
            }
            self.calculateMarkerBounds(self.map);
        } else if (markers.length === 0) {
            this.setDefaults(this.map);
        }
    };

    GoogleMap.prototype.setDefaults = function(map) {
        var lat;
        var lng;
        var address;
        var zooom;
        var isVisible;
        if (this.data.selectedlocationOption === 'datasource addresses') {
            isVisible = this.data.showMapAddr;
            lat = parseFloat(this.data.latAddr);
            lng = parseFloat(this.data.lngAddr);
            address = this.data.addressAddr;
            zooom = this.data.zoomAddr;
        } else if (this.data.selectedlocationOption === 'datasource coordinates') {
            isVisible = this.data.showMapCoor;
            lat = parseFloat(this.data.latCoor);
            lng = parseFloat(this.data.lngCoor);
            address = this.data.addressCoor;
            zooom = this.data.zoomCoor;
        }
        this.deleteMarkers(map);
        if (!isVisible) {
            this.$map.css({
                visibility: 'hidden'
            })
            return;
        }
        if (address) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    var regex = /[(](-?[0-9]*.[0-9]*)[,][ ](-?[0-9]*.[0-9]*)[)]/;
                    var result = regex.exec(results[0].geometry.location.toString());
                    if (result.length >= 3) {
                        var latlng = new google.maps.LatLng(
                            result[1],
                            result[2]);
                        map.setCenter(latlng);
                        map.setZoom(zooom);
                    }
                }
            });
        } else if (lat && lng) {
            map.setCenter({lat: lat, lng: lng});
            map.setZoom(zooom);
        } else { // If no address and lat-lng values are given, sets the map's center on Belgium.
            map.setCenter({lat: 50.503887, lng: 4.469936});
            map.setZoom(7);
        }

    }

    GoogleMap.prototype.deleteMarkers = function() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

    GoogleMap.prototype.calculateMarkerBounds = function(map) {
        if (markers.length === 1) {
            map.setCenter(markers[0].position);
            map.setZoom(14); // Default zoom if database has only one value.
        } else if (markers.length !== 0) {
            var markerBounds = new google.maps.LatLngBounds();
            for (var i = 0; i < markers.length; i++) {
                markerBounds.extend(markers[i].position);
            }
            map.fitBounds(markerBounds);
        }
    }

    GoogleMap.prototype.getMap = function() {
        return this.mapDeferred.promise;
    }

    return GoogleMap;
});
